import Vue from 'vue'
import Vuex from 'vuex'

import ProjectStore from './stores/project'
import CheckingStore from './stores/checking'
import FacultyStore from './stores/faculty'
import UserStore from './stores/user'

Vue.use(Vuex)

const state = {
  loadingStates: {
    project: false,
    checking: false,
    user: false
  },
  layout: {
    isSidebarMinimized: false,
    isSidebarEnabled: false
  }
}

const mutations = {
  setLoadingState (state, { key, isLoading }) { state.loadingStates[key] = isLoading },
  setIsSidebarMinimized (state, isMinimized) { state.layout.isSidebarMinimized = isMinimized },
  setIsSidebarEnabled (state, status) { state.layout.isSidebarEnabled = status }
}

export default new Vuex.Store({
  strict: true,
  state,
  mutations,
  modules: {
    project: ProjectStore,
    checking: CheckingStore,
    user: UserStore,
    faculty: FacultyStore
  }
})
